import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css'],
})
export class EditUserComponent implements OnInit {
  hello = true;
  chekuser: any;
  emailid: any;
  userData: any;
  sign = 'visibility_off';
  professions = [
    { value: 'Civil engineer', viewValue: 'Civil engineer' },
    { value: 'Architect', viewValue: 'Architect' },
    { value: 'Engineer', viewValue: 'Engineer' },
  ];
  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar
  ) {}
  registerForm: FormGroup;
  regFormData: any;
  ngOnInit() {
    this.authService.getEditUserDetails().subscribe((data) => {
      this.userData = data;
    });
    this.registerForm = new FormGroup({
      client: new FormControl('', Validators.required),
      prof: new FormControl('', Validators.required),
      // profession: new FormControl('',Validators.required),
      username: new FormControl('', Validators.required),
      pass: new FormControl('', Validators.required),
      emailid: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ]),

      mobile: new FormControl('', Validators.required),
    });
  }

  editClientDetails() {
    this.authService.editUser(this.registerForm.value).subscribe((data) => {
      this.snackBar.open('User edited successfully', 'clear', {
        duration: 5000,
      });
      this.router
        .navigateByUrl('/register', { skipLocationChange: true })
        .then(() => this.router.navigate(['mrfd']));
    }); // {7}

    //this.formSubmitAttempt = true;             // {8}
  }
  showPassword(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    if (this.sign == 'visibility_off') {
      this.sign = 'visibility';
    } else {
      this.sign = 'visibility_off';
    }
  }
}
